import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';

import PropTypes from 'prop-types';

import { PromoIcon } from 'apps/promo/components/common/promo-icon/PromoIcon';
import PromoSpinner from 'apps/promo/components/common/promo-spinner/PromoSpinner';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import Form from 'apps/promo/components/form-multi/Form';
import PromoComplexPopup from 'apps/promo/components/popup/PromoComplexPopup';
import { ADD_REQUEST_ACQUIRING } from 'apps/promo/constants/formName';

import { DataSent, HubSpotForm, ModalHeader, IconWrapper } from './styles';
import { PromoRow } from '../../PromoRow/PromoRow';

const RequestFormPopup = ({ popupRef = null, ...props }) => {
    const [isFormReady, setIsFormReady] = useState(true);
    const [isFormDataSent, setIsFormDataSent] = useState(false);
    const [isShowSpinner] = useState(false);
    const location = useLocation();

    const formIdMap = {
        en: {
            enterprise: '8b44c6f1-c1e3-4e34-ac9c-180ee9319cc1',
            'instant-account-payout': '8b44c6f1-c1e3-4e34-ac9c-180ee9319cc1',
            acquiring: '33fb0b7f-1519-4da7-b0c7-56c3702249da',
            payments: '33fb0b7f-1519-4da7-b0c7-56c3702249da',
        },
        es: {
            enterprise: 'e14e6803-a06b-4d89-bf9d-6f4a6c5cd6cf',
            'instant-account-payout': 'e14e6803-a06b-4d89-bf9d-6f4a6c5cd6cf',
            acquiring: 'b8b36149-b184-45ac-a94f-a8e79fe29cb6',
            payments: 'b8b36149-b184-45ac-a94f-a8e79fe29cb6',
        },
    };

    const getFormIdBySlug = () => {
        const lang = location.pathname.substring(1, 3);
        const slug = location.pathname.split('/').filter(Boolean).pop();
        const translatedFormLangs = ['es'];

        if (translatedFormLangs.includes(lang)) return formIdMap[lang][slug] || 'b8b36149-b184-45ac-a94f-a8e79fe29cb6';

        return formIdMap['en'][slug] || '33fb0b7f-1519-4da7-b0c7-56c3702249da';
    };

    useEffect(() => {
        setIsFormReady(true);
        setIsFormDataSent(false);

        const script = document.createElement('script');
        script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
        document.body.appendChild(script);

        script.addEventListener('load', () => {
            if (window.hbspt) {
                const formId = getFormIdBySlug();
                window.hbspt.forms.create({
                    region: 'eu1',
                    portalId: '25782218',
                    formId,
                    target: '#hubspotForm',
                    css: '',
                    onFormSubmitted: function () {
                        setIsFormDataSent(true);
                    },
                });
            }
        });
    }, []);

    return (
        <PromoComplexPopup withoutCloseButton={true} popupRef={popupRef} withoutButton={true}>
            {isFormReady && !isFormDataSent && (
                <>
                    {isShowSpinner && <PromoSpinner forceShow insidePopup isEmptyText />}
                    <Form formName={ADD_REQUEST_ACQUIRING}>
                        <ModalHeader>
                            {props.formTitle && (
                                <PromoText variant={'subheader'} color={'baseColor'}>
                                    {props.formTitle}
                                </PromoText>
                            )}
                        </ModalHeader>
                        <HubSpotForm id="hubspotForm"></HubSpotForm>
                    </Form>
                </>
            )}
            {isFormDataSent && (
                <DataSent>
                    <IconWrapper>
                        <PromoIcon name="check-rounded-thin" size="80px" color="primary" />
                    </IconWrapper>
                    {props.formSendTitle && (
                        <PromoRow indent={'adaptive-12-16'}>
                            <PromoText variant={'subheader'} color={'baseColor'} tag={'p'}>
                                {props.formSendTitle}
                            </PromoText>
                        </PromoRow>
                    )}{' '}
                    {props.formSendText && (
                        <PromoText variant={'subheader'} color={'gray40'} tag={'p'}>
                            {props.formSendText}
                        </PromoText>
                    )}
                </DataSent>
            )}
        </PromoComplexPopup>
    );
};

RequestFormPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => {
    return {
        formTitle: state.extra?.strapiApi.request_form?.title,
        formSendTitle: state.extra?.strapiApi.request_form?.send_title,
        formSendText: state.extra?.strapiApi.request_form?.send_text,
        icon: state?.extra?.strapiApi?.request_form?.icon,
    };
};
export default connect(mapStateToProps, null)(RequestFormPopup);
